/**
 * billing模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例

const billing = {
  //账务分页
  pageBilling(params) {
    return $http.post(`${global.API_URL}/sme/billing/page`,params);
  },
  //账务删除
  deleteBilling(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/billing/delete`,param);
  },
  //查询资源类型
  searchResourceType(id, params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/billing/searchResourceType`,param);
  },
  //查询财务监控指标
  searchBillMonitorIndex(params) {
    return $http.post(`${global.API_URL}/sme/billing/searchBillMonitorIndex`,params);
  }

}

export default billing;



// WEBPACK FOOTER //
// ./src/api/billing.js